import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateCollectionRequest,
  DeleteCollectionRequest,
  UpdateCollectionRequest,
  ViewAllCollectionsRequest
} from './collection.types';

import {
  requestCreateCollection,
  requestDeleteCollection,
  requestUpdateCollection,
  requestViewAllCollections
} from './collection.actions';

export const useCollectionApi = () => {
  const dispatch = useDispatch();

  const createCollection = useCallback(
    (requestData: CreateCollectionRequest, onSuccess?: (externalReference: string) => void) => {
      dispatch(requestCreateCollection({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewAllCollections = useCallback(
    (requestData: ViewAllCollectionsRequest, onSuccess?: () => void) => {
      dispatch(requestViewAllCollections({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateCollection = useCallback(
    (requestData: UpdateCollectionRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateCollection({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteCollection = useCallback(
    (requestData: DeleteCollectionRequest, onSuccess?: () => void) => {
      dispatch(requestDeleteCollection({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createCollection, viewAllCollections, updateCollection, deleteCollection };
};
